.preview-content {
    overflow-y: auto;
    height: 100%;
}
